import React from "react";
import Footer from "../../components/Footer/Footer";
import classes from "./About.module.css";
const About = () => {
  return (
    <>
      <div className={classes["page-container"]}></div>
      <Footer></Footer>
    </>
  );
};

export default About;
